(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Helper: set the right maxHeight for a given button's panel
  function setPanelMaxHeight(btn) {
    const panel = btn.nextElementSibling;
    if (! panel) return;

    if (btn.classList.contains('active')) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      panel.style.maxHeight = '';
    }
  }

  // Desktop check + smooth scroll helper (respects reduced motion)
  const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
  function scrollToBottomSmooth() {
    const top = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, top);
    } else {
      window.scrollTo({top, behavior: 'smooth'});
    }
  }

  // 1) Recalculate on window resize (debounced via rAF)
  let resizeRAF;
  function updateOpenPanels() {
    document.querySelectorAll('.accordion.active').forEach(setPanelMaxHeight);
  }

  function onResize() {
    cancelAnimationFrame(resizeRAF);
    resizeRAF = requestAnimationFrame(updateOpenPanels);
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  // 2) Also recalc when panel content itself changes size (images, fonts, reviews widgets)
  const ro = new ResizeObserver(() => {
    updateOpenPanels();
  });
  document.querySelectorAll('.accordion__panel').forEach(panel => ro.observe(panel));

  // 3) Use the same helper in your click handler
  document.querySelectorAll('.accordion').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('active');
      setPanelMaxHeight(btn);

      // If opening on desktop, scroll the section's overflow to bottom after expand
      const panel = btn.nextElementSibling;
      if (panel && btn.classList.contains('active') && isDesktop()) {
        const onEnd = (e) => {
          if (e.propertyName !== 'max-height') return;
          panel.removeEventListener('transitionend', onEnd);

          requestAnimationFrame(() => {
            // FullPage active? scroll the overflow wrapper of the active section
            const overflowEl = document.querySelector('.fp-section.active .fp-overflow');
            if (overflowEl) {
              const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
              overflowEl.scrollTo({ top: overflowEl.scrollHeight, behavior });
            } else {
              // Fallback to native page scroll (mobile/no fullPage)
              scrollToBottomSmooth();
            }
          });
        };
        panel.addEventListener('transitionend', onEnd, { once: true });
      }
    });
  });

  let swiperReadyPromise;

  function whenSwiperReady() {
    if (typeof Swiper !== 'undefined') return Promise.resolve();

    if (!swiperReadyPromise) {
      // Poll for Swiper since the CDN script loads async; avoids "Swiper is not defined" errors.
      swiperReadyPromise = new Promise((resolve) => {
        const check = () => {
          if (typeof Swiper !== 'undefined') {
            resolve();
            return;
          }
          requestAnimationFrame(check);
        };
        check();
      });
    }

    return swiperReadyPromise;
  }

  function initMediaSlider(mediaContainer) {
    if (!mediaContainer) return;

    whenSwiperReady().then(() => {
      const sliderEl = mediaContainer.querySelector('.product__media-wrapper .swiper');
      const thumbnailsEl = document.querySelector('.product__thumbnails');
      if (!sliderEl) return;

      // Prevent double-inits on the same element
      if (sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
      }

      const totalSlides = sliderEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
      const prevEl = mediaContainer.querySelector('.product-media-slider__nav--prev') || null;
      const nextEl = mediaContainer.querySelector('.product-media-slider__nav--next') || null;
      const indexEls = mediaContainer.querySelectorAll('.product-media-slider__index');

      const swiper = new Swiper(sliderEl, {
        loop: totalSlides > 1,
        speed: 400,
        navigation: (prevEl && nextEl) ? { prevEl, nextEl } : {},
        grabCursor: true,
        simulateTouch: true,
        threshold: 5,
        touchAngle: 15,
        // Helps when the container is injected/hidden then shown
        observer: true,
        observeParents: true,
        on: {
          init(s) { updateMediaIndex(s); },
          imagesReady(s) { s.update(); updateMediaIndex(s); },
          slideChange(s) { updateMediaIndex(s); }
        }
      });

      function updateMediaIndex(s) {
        const current = (s.params.loop ? s.realIndex : s.activeIndex) + 1;
        indexEls.forEach(el => { el.textContent = `Image ${current}/${totalSlides}`; });
        updateThumbnailActiveState(current - 1);
      }

      function updateThumbnailActiveState(activeIndex) {
        if (!thumbnailsEl) return;
        thumbnailsEl.querySelectorAll('.product__thumbnail').forEach((thumbEl, idx) => {
          if (idx === activeIndex) {
            thumbEl.classList.add('product__thumbnail--active');
          } else {
            thumbEl.classList.remove('product__thumbnail--active');
          }
        });
      }

      // Thumbnail click handling
      if (thumbnailsEl) {
        thumbnailsEl.querySelectorAll('.product__thumbnail').forEach((thumbEl) => {
          thumbEl.addEventListener('click', () => {
            const index = parseInt(thumbEl.getAttribute('data-prodify-thumbnail-index'));
            if (!isNaN(index)) {
              swiper.slideToLoop(index);
            }
          });
        });
      }
    });
  }

  function bootstrapAllMediaSliders() {
    document.querySelectorAll('[data-prodify-media-container]').forEach(initMediaSlider);
  }

  // Run once on initial load
  bootstrapAllMediaSliders();

  // Re-run when sections or product content are swapped into the DOM
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        // If a whole product section was injected
        if (node.matches?.('[data-prodify-media-container]')) {
          initMediaSlider(node);
        }
        // Or if just the inner media was injected
        node.querySelectorAll?.('[data-prodify-media-container]').forEach(initMediaSlider);
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });


  document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector('.shopify-section-main-product-inner');
    if (section) {
      requestAnimationFrame(() => {
        section.classList.add('is-visible');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
